<template>
  <div class="options-wrap">
    <div class="options__btn" @click="options = !options">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="options" v-if="showDropdown">
      <router-link v-for="item in optionsLink"
                   :to="to(item)"
                   class="options__link"
                   :key="item.to + id"
                   @click.native="sendActive(item.to)"
      >
        {{item.name}}
      </router-link>
      <button class="options__close" @click="options = false">
        <img src="/img/x.svg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Options",
    data() {
      return {
        options: false,
        optionsLink: [
          {
            name: 'Редактировать',
            to: '-edit'
          },
          {
            name: 'Отключить',
            to: '-disable'
          },
          {
            name: 'Удалить',
            to: '-delete'
          }
        ]
      }
    },
    props: {
      namePage: {
        type: String,
        required: true
      },
      id: {
        required: true
      },
      parentMouse: {
        type: Boolean,
        required: true
      },
      active: {
        type: String
      },
      data: {
        type: Object
      }
    },
    methods: {
      sendActive(to) {
        if (to === '') {
          let params = {};
          Object.assign(params, this.$route.params);
          Object.assign(params, this.data);
          params.status = 'active';
          params.id = this.id;
          this.$store.dispatch(this.active, params)
            .then(res => {
              this.$emit('updateData');
            });
        }
      },
      to(item) {
        if (this.$route.name === 'designer-generations-questions') {
          if (item.name === 'Ответы') {
            return {name: item.to, params: {q_id: this.id}};
          }
          else {
            return {name: item.to, params: {id: this.id}};
          }
        }
        else {
          return item.to === '' ? '' : {name: this.namePage + item.to, params: {id: this.id}}
        }
      }
    },
    computed: {
      showDropdown() {
        if (!this.parentMouse) {
          this.options = false;
        }
        return this.options;
      },
    },
    created() {
      if (this.$route.name === 'designer-generations-questions') {
        this.optionsLink = [
          {
            name: 'Ответы',
            to: 'designer-answers'
          },
          {
            name: 'Редактировать',
            to: 'designer-generations-questions-edit'
          }
        ];
      }
      else if (this.data.status === 'inactive') {
        this.optionsLink[1].name = 'Включить';
        this.optionsLink[1].to = '';
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .options {
    position: absolute;
    left: 50%;
    top: calc(100% + 15px);
    display: none;
    flex-direction: column;
    width: 200px;
    padding: 20px 45px;
    background-color: $black;
    transform: translateX(-50%);
    @media (max-width: 575px) {
      z-index: 7;
      left: unset;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      transform: none;
    }
    &:after {
      position: absolute;
      bottom: 100%;
      left: 50%;
      content: '';
      border: 9px solid transparent;
      border-bottom: 9px solid $black;
      transform: translateX(-50%);
      @media (max-width: 575px) {
        display: none;
      }
    }
    &__close {
      position: absolute;
      top: 9px;
      right: 9px;
      display: none;
      padding: 0;
      border: none;
      background-color: transparent;
      cursor: pointer;
      @media (max-width: 575px) {
        display: block;
      }
    }
    &__link {
      display: inline-block;
      margin: 5px 0;
      color: #ffffff;
      text-decoration: none;
      &:hover {
        color: $blue;
      }
    }
    &-wrap {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10;
      display: flex;
      justify-content: center;
      opacity: 0;
      @media (max-width: 991px) {
        opacity: 1;
      }
      @media (max-width: 575px) {
        position: static;
      }
      &-questions {
        top: 17px;
        right: 17px;
        @media (max-width: 575px) {
          top: 0;
          right: 0;
          .options {
            flex-direction: row;
            align-items: center;
            padding: 0 12px;
            &__link {
              padding: 0 12px;
            }
          }
        }
      }
    }
    &-parent {
      position: relative;
      &:hover {
        .options-wrap {
          z-index: 11;
          opacity: 1;
        }
        .options {
          display: flex;
        }
      }
      &--visible {
        .options-wrap {
          opacity: 1;
        }
      }
    }
    &__btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 24px;
      background-color: $blue;
      cursor: pointer;
      transition: $transition;
      @media (max-width: 575px) {
        position: absolute;
        z-index: 6;
        top: 0;
        right: 0;
      }
      &:hover {
        background-color: darken($blue, 5);
      }
      span {
        width: 16px;
        height: 2px;
        margin: 1.5px 0;
        background-color: #fff;
	cursor: pointer !important;
      }
    }
  }

  .options-wrap:not(.options-wrap-questions) {
    .options {
      @media (max-width: 575px) {
        justify-content: center;
      }
    }
  }
</style>
